// export const tenancyModule = ":8487/";
// export const masterModule = ":8185/";
// export const blobstorageModule = ":9036/";
// export const inwardModule = ":8971/";
// export const tmsModule = ":8763/";

export const tenancyModule = "/tenancy/";
export const masterModule = "/master/";
export const blobstorageModule = "/blob/";
export const inwardModule = "/inward/";
export const tmsModule = "/tms/";
